import { IError } from "@core/entities";
import { RolesState } from "@modules/roles/entities";
import * as RolesAction from "@modules/roles/store/actions/roles.action";
import { EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { Action, createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";

export const errorsAdapter: EntityAdapter<IError> = createEntityAdapter<IError>({
  selectId: b => b.id,
  sortComparer: (bA, bB) => (bA.id > bB.id ? 1 : -1),
});

const initialState: RolesState = {
  ui: { openUpsertModal: false },
  permissionGroups: [],
  selectedPermissionGroup: undefined,
};

const RolesReduce = createReducer(
  initialState,
  on(RolesAction.clearAll, () => initialState),
  on(RolesAction.setUi, (state, { ui }) => ({ ...state, ui: { ...state.ui, ...ui } })),
  on(RolesAction.setPermissionGroups, (state, { payload }) => ({ ...state, permissionGroups: payload })),
  on(RolesAction.setSelectedPermissionGroup, (state, { payload }) => ({ ...state, selectedPermissionGroup: payload })),
  on(RolesAction.modifySelectedPermissionGroup, (state, { payload }) => ({
    ...state,
    selectedPermissionGroup: { ...state.selectedPermissionGroup, ...payload },
  }))
);

export function RolesReducer(state: RolesState, action: Action) {
  return RolesReduce(state, action);
}

export const getRolesStore = createFeatureSelector<RolesState>("roles");

export const getUiRoles = createSelector(getRolesStore, ({ ui }) => ui);
export const getPermissionGroups = createSelector(getRolesStore, ({ permissionGroups }) => permissionGroups);
export const getSelectedPermissionGroup = createSelector(getRolesStore, ({ selectedPermissionGroup }) => selectedPermissionGroup);
